import { injectChurnZero } from "./churnZero/churnZero";

export const analyticsInfoEndpoint = "CompanyUser/GetAnalyticsInfo";

export function injectAnalytics(){
    injectChurnZero();
}

